export const actionTypes: any = {
  // get head hunt applications
  GET_HEAD_HUNT_APPLICATIONS_START: 'GET_HEAD_HUNT_APPLICATIONS_START',
  GET_HEAD_HUNT_APPLICATIONS_SUCCESS: 'GET_HEAD_HUNT_APPLICATIONS_SUCCESS',
  GET_HEAD_HUNT_APPLICATIONS_FINISH: 'GET_HEAD_HUNT_APPLICATIONS_FINISH',

  // Update head hunt application (status transition)
  UPDATE_HEAD_HUNT_APPLICATIONS_START: 'UPDATE_HEAD_HUNT_APPLICATIONS_START',
  UPDATE_HEAD_HUNT_APPLICATIONS_SUCCESS: 'UPDATE_HEAD_HUNT_APPLICATIONS_SUCCESS',
  UPDATE_HEAD_HUNT_APPLICATIONS_FINISH: 'UPDATE_HEAD_HUNT_APPLICATIONS_FINISH',
  UPDATE_HEAD_HUNT_APPLICATIONS_RESET: 'UPDATE_HEAD_HUNT_APPLICATIONS_RESET',

  // delete head hunt applications
  DELETE_HEAD_HUNT_APPLICATIONS_START: 'DELETE_HEAD_HUNT_APPLICATIONS_START',
  DELETE_HEAD_HUNT_APPLICATIONS_SUCCESS: 'DELETE_HEAD_HUNT_APPLICATIONS_SUCCESS',
  DELETE_HEAD_HUNT_APPLICATIONS_FINISH: 'DELETE_HEAD_HUNT_APPLICATIONS_FINISH',

  // get single head hunt application (view-details modal)
  GET_HEAD_HUNT_APPLICATION_START: 'GET_HEAD_HUNT_APPLICATION_START',
  GET_HEAD_HUNT_APPLICATION_SUCCESS: 'GET_HEAD_HUNT_APPLICATION_SUCCESS',
  GET_HEAD_HUNT_APPLICATION_FINISH: 'GET_HEAD_HUNT_APPLICATION_FINISH',
  GET_HEAD_HUNT_APPLICATION_RESET: 'GET_HEAD_HUNT_APPLICATION_RESET',
}
